import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWoman = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "woman",
	width: "16px",
	height: "17px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "woman" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			fillRule: "evenodd",
			fill: "currentColor",
			transform: "translate(-726.000000, -712.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Page-1",
				transform: "translate(158.000000, 213.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					transform: "translate(568.000000, 499.000000)",
					children: /* @__PURE__ */ _jsx("path", { d: "M13.9443,12.1701 C13.9443,12.1701 12.7573,11.8041 10.8313,11.1261 C10.8133,10.7901 10.5613,10.3401 10.1183,10.3401 L9.4923,10.3401 L9.5853,9.0011 L12.9953,9.0011 C12.9953,9.0011 11.7323,6.8021 11.4343,4.1181 C11.4393,3.9411 11.4433,3.7241 11.4433,3.4321 C11.4433,2.4711 11.1863,0.0041 7.9823,0.0041 C7.9553,0.0031 8.0023,0.0021 8.0113,0.0011 C8.0103,0.0001 8.0093,0.0001 8.0083,0.0001 C7.9723,0.0001 7.9373,0.0031 7.9023,0.0041 C5.0343,0.0041 4.5873,2.4131 4.5873,3.4321 C4.5873,3.6211 4.5923,3.9121 4.6023,4.2041 C4.2883,6.9131 3.0213,9.0011 3.0213,9.0011 L6.4443,9.0011 L6.5353,10.3401 L5.9103,10.3401 C5.4673,10.3401 5.2223,10.8211 5.1973,11.1571 C3.3333,11.8661 1.8653,12.2641 1.8653,12.2641 C0.4703,12.8051 0.0413,13.4501 0.0003,14.1561 L0.0003,15.5321 L0.0333,15.5321 C0.0563,15.6251 0.1023,15.7041 0.1583,15.7761 C0.2383,15.8811 0.3433,15.9561 0.4693,15.9901 C0.5173,16.0031 0.5633,16.0171 0.6153,16.0171 L15.3833,16.0171 C15.5543,16.0171 15.7023,15.9341 15.8093,15.8111 C15.8793,15.7331 15.9363,15.6411 15.9653,15.5321 L15.9973,15.5321 L15.9973,14.1561 C15.8633,13.6691 15.4953,12.8671 13.9443,12.1701 M8.0193,0.0001 C8.0273,0.0001 8.0143,0.0001 8.0113,0.0011 L8.0143,0.0011 C8.0163,0.0011 8.0173,0.0001 8.0193,0.0001" })
				})
			})
		})
	]
});
export default SvgWoman;
